module.exports = __webpack_public_path__ + "static/media/aim-box.512e9be2.svg";